import config from '../config';
import Service from './service';

var pathKey = process.env.SKIP_CDN ? 'url' : 'cdn';

var emailConnect = new Service(config.emailConnect[pathKey]);
var me = new Service(config.me[pathKey]);
var moderation = new Service(config.moderation[pathKey]);
var socialConnect = new Service(config.socialConnect[pathKey]);
var tmsBE = new Service(config.tmsBE);

export {
  emailConnect,
  me,
  moderation,
  socialConnect,
  tmsBE
};
